import React from 'react'
import { Box } from '@mui/material'
import Title from '../components/Title'
import DialogAdd from './Add'
import Liste from './Liste'
import SearchBar from './SearchBar'

export default function Blog() {
    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }} >
                {/*---------------- debut titre --------------*/}
                <Title
                    intitule='Blog'
                />
                {/*---------------- fin titre --------------*/}


                {/*---------------- debut add --------------*/}

                <Box sx={{ width: "50%" }}>
                    <SearchBar />
                </Box>

                {/*---------------- fin add --------------*/}


                {/*---------------debut SearchBar --------- */}

                <Box>
                    <DialogAdd />
                </Box>

                {/* ------------------fin  SearchBar ------------*/}
            </Box>

            {/*---------------- debut Liste -----------------*/}
            <Liste />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
